// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconPlpGrid = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9,0 L16,0 L16,7 L9,7 Z M9,9 L16,9 L16,16 L9,16 Z M0,0 L7,0 L7,7 L0,7 Z M0,9 L7,9 L7,16 L0,16 Z"
            />
        </svg>
    );
};

export default React.memo(IconPlpGrid);
